
import { DashboardMenu } from "../../data/menu"
import BreadCrump from "../tools/breadcrump"
import { getCookies } from "cookies-next";
import { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import changeUrl from "../../hoc/changeur";
import { config } from "../../data/config";

import { useTranslation } from 'react-i18next';
import HeaderOfPage from "../tools/headerOfPage";

export default function ListBrands() {
    const { t } = useTranslation();

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Products',
            url: '/dashboard/Products'
        },
        {
            name: 'لیست برندها',
            url: null
        },
    ]
    const reloadgame = () => {
        let x = key + 1;
        setKey(x);
    }
    const [key, setKey] = useState(1);

    return (
        <>
            <div className="text-left  bg-white  p-3 m-4    h-[100vh] mb-5 ">
                <BreadCrump data={breadcrump}></BreadCrump>
                <HeaderOfPage name="لیست برندها"></HeaderOfPage>


                <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
                    <div className="col-span-1 directions ">
                        <NewBrand reloaditem={reloadgame}></NewBrand>

                    </div>
                    <div className="col-span-3 directions">
                        <ListofBrand key={key}></ListofBrand>
                    </div>
                </div>
            </div>

        </>
    )
}
function ListofBrand() {
    const { t } = useTranslation();

    let cookie = getCookies();
    const [list, setList] = useState<any>(null);

    const [error, setError] = useState<any>(null);
    const [key, setKey] = useState<any>(1);

    const getalldata = async (mypage: any = 1) => {
        setError(null);

        try {
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/brands?page=' + mypage,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            //let mydata = res.data;
            //  console.log(config.url + '/v1/dashboard/bloggroup')
            //  console.log(res);
            setList(res.data.message);
        } catch (error: any) {

            // error.response.data.code != null && Swal.fire(` "${data.url}" slug is available.`);
            setError(error.response.data.message.errors);
        }
    }
    const deleted = async (id: any) => {

        Swal.fire({
            title: t("Are you sure?"),
            text: t("Delete this Group!"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t("Yes, delete it!")
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    let res = await axios({
                        method: 'delete',
                        url: config.url + '/v1/dashboard/brands/' + id,
                        headers: {
                            Authorization: 'Bearer ' + cookie['token'],
                        }
                    })

                    getalldata();
                } catch (error) {
                    console.log(error);
                }
            }
        });

    }
    useEffect(() => {
        getalldata();
    }, []);
    return (
        <div>
            <div className="grid grid-cols-2 pb-4">


            </div>
            <hr />

            <div className="flex flex-col text-right">
                <div className="-m-1.5 overflow-x-auto">
                    <div className="p-1.5 min-w-full inline-block align-middle">
                        <div className="overflow-hidden">
                            <table className="min-w-full divide-y divide-gray-200 ">
                                <thead>
                                    <tr>
                                        <th scope="col" className="px-6 py-3  text-xs font-medium text-gray-500 uppercase ">{t('Name')}  </th>
                                        <th scope="col" className="px-6 py-3  text-xs font-medium text-gray-500 uppercase ">{t('SLUG')}</th>
                                        <th scope="col" className="px-6 py-3  text-xs font-medium text-gray-500 uppercase  ">{t('Action')} </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {list != null && list.docs.map((item: any) => {
                                        // Handle multilingual name display
                                        const displayName = typeof item.name === 'object' 
                                            ? (item.name.en || item.name.fa || item.name.ku || item.name.ar || item.name.tr || '') 
                                            : item.name;
                                        return (
                                            <tr className="odd:bg-white even:bg-gray-100 hover:bg-gray-100 ">
                                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800 ">{displayName}</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800 ">{item.url}</td>

                                                <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium flex gap-2">
                                                    <a
                                                        href={`/dashboard/Products/Brands/${item.id}`}
                                                        type="button"
                                                        className="inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent text-blue-600 hover:text-blue-800 focus:outline-none focus:text-blue-800 disabled:opacity-50 disabled:pointer-events-none "
                                                    >
                                                        <img src="/icons/editgreen.svg" width={20} alt="Edit" />

                                                    </a>

                                                    <button
                                                        onClick={(e) => { deleted(item.id) }}
                                                        type="button"
                                                        className="inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent text-blue-600 hover:text-blue-800 focus:outline-none focus:text-blue-800 disabled:opacity-50 disabled:pointer-events-none "
                                                    >
                                                        <img src="/icons/delred.svg" width={20} alt="Del" />
                                                    </button>
                                                </td>

                                            </tr>
                                        )
                                    })}



                                </tbody>
                            </table>
                        </div>
                        <div className="mt-4">
                            <nav className="flex items-center -space-x-px" aria-label="Pagination">
                                {list != null && list.prevPage != null &&
                                    <button
                                        onClick={(e) => { getalldata(list.page - 1); }}
                                        type="button" className="min-h-[38px] min-w-[38px] py-2 px-2.5 inline-flex justify-center items-center gap-x-1.5 text-sm first:rounded-s-lg last:rounded-e-lg border border-gray-200 text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none" aria-label="Previous">
                                        <svg className="shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                            <path d="m15 18-6-6 6-6"></path>
                                        </svg>
                                        <span className="hidden sm:block">{t('Previous')} </span>
                                    </button>
                                }
                                {list != null &&
                                    Array.from({ length: list.totalPages }, (_, index) => index + 1).map((item) => {
                                        return (
                                            list.page == item ?
                                                <button type="button" className="min-h-[38px] min-w-[38px] flex justify-center items-center bg-gray-200 text-gray-800 border border-gray-200 py-2 px-3 text-sm first:rounded-s-lg last:rounded-e-lg focus:outline-none focus:bg-gray-300 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-600 dark:border-neutral-700 dark:text-white dark:focus:bg-neutral-500" aria-current="page">{item}</button>

                                                :
                                                <button
                                                    onClick={(e) => { getalldata(item); }}
                                                    type="button" className="min-h-[38px] min-w-[38px] flex justify-center items-center border border-gray-200 text-gray-800 hover:bg-gray-100 py-2 px-3 text-sm first:rounded-s-lg last:rounded-e-lg focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none">{item}</button>
                                        )

                                    })
                                }

                                {list != null && list.nextPage != null &&
                                    <button
                                        onClick={(e) => { getalldata(list.page + 1); }}
                                        type="button" className="min-h-[38px] min-w-[38px] py-2 px-2.5 inline-flex justify-center items-center gap-x-1.5 text-sm first:rounded-s-lg last:rounded-e-lg border border-gray-200 text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none " aria-label="Next">
                                        <span className="hidden sm:block">{t('Next')}</span>
                                        <svg className="shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                            <path d="m9 18 6-6-6-6"></path>
                                        </svg>
                                    </button>
                                }
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}
type LanguageCode = 'ku' | 'fa' | 'en' | 'ar' | 'tr';

interface MultilingualField {
    ku: string;
    fa: string;
    en: string;
    ar: string;
    tr: string;
    [key: string]: string;
}

interface BrandData {
    name: MultilingualField;
    url: string;
    keywords: MultilingualField;
    description: MultilingualField;
    parent: null;
}

function NewBrand({ reloaditem }: any) {
    const { t } = useTranslation();

    let cookie = getCookies();
    const [data, setData] = useState<BrandData>({
        name: { ku: '', fa: '', en: '', ar: '', tr: '' },
        url: '',
        keywords: { ku: '', fa: '', en: '', ar: '', tr: '' },
        description: { ku: '', fa: '', en: '', ar: '', tr: '' },
        parent: null

    });
    const [error, setError] = useState(null);
    const [key, setKey] = useState(1);
    const [activeLang, setActiveLang] = useState<LanguageCode>('en');
    const languages: Array<{ code: LanguageCode; label: string }> = [
        { code: 'ku' as LanguageCode, label: 'Kurdish' },
        { code: 'fa' as LanguageCode, label: 'فارسی' },
        { code: 'en' as LanguageCode, label: 'English' },
        { code: 'ar' as LanguageCode, label: 'العربية' },
        { code: 'tr' as LanguageCode, label: 'Türkçe' }
    ];

    // Helper function to safely access multilingual fields
    const getMultilingualValue = (field: MultilingualField, lang: LanguageCode): string => {
        return field[lang] || '';
    };

    const setName = (name: string) => {
        // Only generate slug when typing in the first language (English)
        const firstLang: LanguageCode = 'en';
        const updatedName = { 
            ...data.name, 
            [activeLang]: name 
        };
        
        // Only update slug if we're editing the first language
        let newUrl = data.url;
        if (activeLang === firstLang) {
            newUrl = String(changeUrl(name));
        }
        
        setData({ 
            ...data, 
            url: newUrl, 
            name: updatedName
        });
    }
    const save = async () => {
        setError(null);

        try {
            let res = await axios({
                method: 'post',
                url: config.url + '/v1/dashboard/brands',
                data: data,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            let mydata = res.data;
            // Reset form
            setData({
                name: { ku: '', fa: '', en: '', ar: '', tr: '' },
                url: '',
                keywords: { ku: '', fa: '', en: '', ar: '', tr: '' },
                description: { ku: '', fa: '', en: '', ar: '', tr: '' },
                parent: null
            });
            reloaditem();
            let x = key + 1;
            setKey(x);
            return mydata;
        } catch (error: any) {

            error.response.data.code != null && Swal.fire(` "${data.url}" slug is available.`);
            setError(error.response.data.message.errors);
        }
    }

    const inputstyle = "py-3 px-5 block w-full border-gray-499 rounded text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none";
    return (
        <div className="bg-black text-right rounded-[10px] p-5">
            <h4 className="text-white text-[20px] font-bold ">{t('برند جدید')} </h4>
            <hr />

            <form key={key}>
                {/* Language Selector */}
                <div className="max-w-sm space-y-3">
                    <label className="text-white">زبان / Language</label>
                    <div className="flex gap-2 flex-wrap">
                        {languages.map((lang) => (
                            <button
                                key={lang.code}
                                type="button"
                                onClick={() => setActiveLang(lang.code)}
                                className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${
                                    activeLang === lang.code
                                        ? 'bg-blue-600 text-white'
                                        : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                                }`}
                            >
                                {lang.label}
                            </button>
                        ))}
                    </div>
                </div>
                <div className="max-w-sm space-y-3 mt-4">
                    <label className="text-white"> {t('Name')} ({languages.find(l => l.code === activeLang)?.label}) </label>
                    <input
                        type="text"
                        value={getMultilingualValue(data.name, activeLang)}
                        className={`${inputstyle}     ${error != null && error['name'] != undefined && `bg-red-100`} `}
                        placeholder="Name"
                        onChange={(e) => { setName(e.target.value); }}
                    />
                    {error != null && error['url'] != undefined && <small>{error['name']['message']}</small>}
                </div>
                <div className="max-w-sm space-y-3 mt-4">
                    <label className="text-white"> Slug </label>
                    <input
                        value={data.url}
                        type="text"
                        className={`${inputstyle}       ${error != null && error['url'] != undefined && `bg-red-100`}  `}
                        placeholder="Slug"
                        onChange={(e) => setData({ ...data, url: e.target.value })}
                    />
                    {error != null && error['url'] != undefined && <small>{error['url']['message']}</small>}
                </div>
                <div className="max-w-sm space-y-3 mt-4">
                    <label className="text-white">{t('Keywords')} ({languages.find(l => l.code === activeLang)?.label})</label>
                    <textarea
                        value={getMultilingualValue(data.keywords, activeLang)}
                        className={inputstyle}
                        onChange={(e) => setData({ 
                            ...data, 
                            keywords: { 
                                ...data.keywords, 
                                [activeLang]: e.target.value 
                            } 
                        })}
                        placeholder="..." />
                </div>
                <div className="max-w-sm space-y-3 mt-4">
                    <label className="text-white">{t('Description')} ({languages.find(l => l.code === activeLang)?.label})</label>
                    <textarea
                        value={getMultilingualValue(data.description, activeLang)}
                        className={inputstyle}
                        onChange={(e) => setData({ 
                            ...data, 
                            description: { 
                                ...data.description, 
                                [activeLang]: e.target.value 
                            } 
                        })}
                        placeholder="..." />
                </div>
                <div className="max-w-sm space-y-3 mt-4">
                    <button type="button"
                        onClick={(e) => { save() }}
                        className="py-3 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 focus:outline-none focus:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:hover:text-white dark:focus:bg-white/20 dark:focus:text-white"
                    >
                        {t('Add Category')}
                    </button>

                </div>
            </form>
        </div>
    )
}